<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loading"
    >
      <b-card>
        <b-row class="mb-1">
          <b-col md="3">
            <label for="search-id">Search by ID</label>
            <b-form-input
              id="search-id"
              v-model="filter.id"
            />
          </b-col>
          <b-col md="3">
            <label for="search-state">Search by job state</label>
            <v-select
              id="search-state"
              v-model="filter.jobState"
              :options="statesOptions"
            />
          </b-col>
          <b-col md="3">
            <label for="search-operation">Search by action</label>
            <v-select
              id="search-operation"
              v-model="filter.operation"
              :options="operationOptions"
            />
          </b-col>
          <b-col
            md="3"
            class="d-flex align-items-end justify-content-end"
          >
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="fetchBulks"
            >
              <feather-icon
                icon="RefreshCwIcon"
              />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="position-relative"
          :items="tableData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching bulks found"
          :per-page="perPage"
          :current-page="page"
          :sort-by.sync="sortBy"
        >
          <template #cell(download)="data">
            <b-button
              v-if="canDownload(data)"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              :disabled="data.item.downloading"
              @click="downloadBulk(data)"
            >
              <b-spinner
                v-if="data.item.downloading"
                small
              />
              <feather-icon
                v-else
                icon="DownloadCloudIcon"
              />
            </b-button>
          </template>
        </b-table>
        <base-pagination
          v-model="page"
          :total="tableData.length"
          @new-per-page="perPage = $event"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BFormInput, BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useTransactionBulksList from '../hooks/useTransactionBulksList'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import billingStore from '../../billingStore'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BCard,
    BTable,
    BOverlay,
    BFormInput,
    BRow,
    BCol,
    BasePagination,
    BButton,
    vSelect,
    BSpinner,
  },
  setup(_, ctx) {
    useRegisterStoreModule('billing', billingStore)
    return {
      ...useTransactionBulksList(ctx),
    }
  },
}
</script>

<style>

</style>
